
module.exports = {
    state: {
        // Menus as menuName:value
        menus   : {},
        user    : null,
    },
    getters:{
        mainMenu: ({menus}) => menus.main||[],
    },
    mutations: {
        /**
         * Set the menu, example: {main:[{name:'item'...}]} sets the main menu
         */
        setMenu({menus},payload){ Object.assign(menus,payload); },

        setUser(store,payload){Object.assign(store,{user:payload});},

        setClient(store,payload){Object.assign(store,{client:payload});},

        load(store,payload){Object.assign(store,payload);},
    },
    actions:{
        refresh(store){
            axios.get('/vuex-resource')
                .then(r=>{
                   if(r && r.data&& r.data.data){
                       let data = r.data.data;
                       console.info('Refreshing vuex store...',data)
                       store.commit('load',data);
                   }
                })
                .catch(e=>{console.error('Vuex store refresh error:',e);})
                ;
        }
    }
};
